'use strict';

const exampleBtn = document.querySelector('.btn-example');
const calculateBtn = document.querySelector('.btn-calculate');
const text = document.querySelector('.text');
const publicText = document.querySelector('.public-text');
const publicBtn = document.querySelector('.public-button');
const publicContainer = document.querySelector('.public-display');
const cardContainer = document.querySelector('.card-container');

exampleBtn.addEventListener('click', e => {
  //   const exampleText = `
  // Jane Doe Johnson
  // 2023/10/01	08:25:36	14:25:54	06:00:18 (6.00)
  // 2023/10/02	08:22:12	12:57:58	04:35:46 (4.59)
  // 2023/10/03	08:51:41	18:29:40	09:37:59 (9.63)
  // 2023/10/04	08:36:51	17:52:00	09:15:09 (9.25)
  // 2023/10/05	08:35:51	18:34:26	09:58:35 (9.97)
  // 2023/10/06	08:47:13	18:44:36	09:57:23 (9.95)
  // 2022/10/07	08:36:26	18:35:04	09:58:38 (9.97)
  // 2022/10/10	09:08:48	18:33:41	09:24:53 (9.41)
  // 2022/10/11	08:59:29	18:40:35	09:41:06 (9.68)
  // 2022/10/12	08:59:55	18:43:43	09:43:48 (9.73)
  // 2022/10/13	09:08:53	18:36:01	09:27:08 (9.45)
  // 2022/10/14	08:57:54	18:31:14	09:33:20 (9.55)
  // 2022/10/17	09:05:53	18:39:14	09:33:21 (9.55)
  // 2022/10/18	09:48:51	18:35:58	08:47:07 (8.78)
  // 2022/10/19	08:59:04	18:43:00	09:43:56 (9.73)
  // 2022/10/20	09:07:42	18:37:58	00:00:00 (0.00)
  // 2022/10/21	08:50:49	18:39:45	09:48:56 (9.81)
  // 2022/10/22	08:22:07	14:38:27	06:16:20 (6.27)
  // 2022/10/23	08:09:09	13:08:13	04:59:04 (4.98)
  // 2022/10/25	07:58:18	18:39:20	10:41:02 (10.68)
  // 2022/10/26	08:11:27	19:07:20	10:55:53 (10.93)
  // 2022/10/27	08:09:39	19:05:53	10:56:14 (10.93)
  // 2022/10/28	08:03:35	17:54:37	09:51:02 (9.85)
  // 2022/10/29	12:47:34	16:51:57	04:04:23 (4.07)
  // 2022/10/31	08:01:12	18:39:45	10:38:33 (10.64)`;

  const exampleText = `
Kathleen Robin Hughes
2023/01/02	08:53:09	18:34:26	09:41:17 (9.68)
2023/01/08	08:44:29	18:23:22	09:38:53 (9.64)
2023/10/05	08:43:32	17:44:30	09:00:58 (9.01)
2023/10/06	08:45:50	18:18:13	09:32:23 (9.53)
2023/10/07	08:43:28	16:40:27	07:56:59 (7.94)
2023/10/10	07:00:07	16:51:39	08:00:32 (8.00)
2023/10/11	07:03:05	16:05:25	09:02:20 (9.03)
2023/10/12	08:56:38	18:37:05	09:40:27 (9.67)
2023/10/13	08:28:30	16:45:00	08:16:30 (8.27)
2023/10/18	08:51:45	18:08:32	09:16:47 (9.27)
2023/10/19	08:48:27	18:18:51	09:30:24 (9.50)
2023/10/20	08:49:33	18:26:59	09:37:26 (9.62)
2023/10/21	08:52:34	18:03:25	09:10:51 (9.18)
2023/10/24	08:58:35	18:36:39	09:38:04 (9.63)
2023/10/25	08:45:32	18:39:14	09:53:42 (9.89)
2023/10/26	08:50:20	18:53:42	10:03:22 (10.05)
2023/10/27	08:55:40	18:51:52	09:56:12 (9.93)
2023/10/28	09:03:03	17:57:35	08:54:32 (8.90)
2023/10/31	08:12:37	18:24:33	10:11:56 (10.19)
Ralph Steven Bentley
2023/10/01	08:25:36	14:25:54	06:00:18 (6.00)
2023/10/02	08:22:12	12:57:58	04:35:46 (4.59)
2023/10/03	08:51:41	18:29:40	09:37:59 (9.63)
2023/10/04	08:36:51	17:52:00	09:15:09 (9.25)
2023/10/05	08:35:51	18:34:26	09:58:35 (9.97)
2023/10/06	08:47:13	18:44:36	09:57:23 (9.95)
2023/10/07	08:36:26	18:35:04	09:58:38 (9.97)
2023/10/10	09:08:48	18:33:41	09:24:53 (9.41)
2023/10/11	08:59:29	18:40:35	09:41:06 (9.68)
2023/10/12	08:59:55	18:43:43	09:43:48 (9.73)
2023/10/13	09:08:53	18:36:01	09:27:08 (9.45)
2023/10/14	08:57:54	18:31:14	09:33:20 (9.55)
2023/10/17	09:05:53	18:39:14	09:33:21 (9.55)
2023/10/18	09:48:51	18:35:58	08:47:07 (8.78)
2023/10/19	08:59:04	18:43:00	09:43:56 (9.73)
2023/10/20	09:07:42	18:37:58	00:00:00 (0.00)
2023/10/21	08:50:49	18:39:45	09:48:56 (9.81)
2023/10/22	08:22:07	14:38:27	06:16:20 (6.27)
2023/10/23	08:09:09	13:08:13	04:59:04 (4.98)
2023/10/25	07:58:18	18:39:20	10:41:02 (10.68)
2023/10/26	08:11:27	19:07:20	10:55:53 (10.93)
2023/10/27	08:09:39	19:05:53	10:56:14 (10.93)
2023/10/28	08:03:35	17:54:37	09:51:02 (9.85)
2023/10/29	12:47:34	16:51:57	04:04:23 (4.07)
2023/10/31	08:01:12	18:39:45	10:38:33 (10.64)
Bruce Palmer
2023/10/03	08:29:17	18:31:30	10:02:13 (10.03)
2023/10/04	08:27:14	18:31:30	10:04:16 (10.07)
2023/10/05	08:20:00	18:32:37	10:12:37 (10.21)
2023/10/06	08:21:34	18:44:31	10:22:57 (10.38)
2023/10/07	08:10:14	18:00:10	09:49:56 (9.83)
2023/10/10	08:16:13	18:33:35	10:17:22 (10.28)
2023/10/11	08:28:47	18:40:40	10:11:53 (10.19)
2023/10/12	08:35:23	18:45:33	10:10:10 (10.16)
2023/10/13	08:27:17	18:33:26	10:06:09 (10.10)
2023/10/14	08:29:58	18:19:29	09:49:31 (9.82)
2023/10/15	07:39:01	13:23:52	05:44:51 (5.74)
2023/10/16	08:11:24	13:13:47	05:02:23 (5.03)
2023/10/17	08:39:55	18:41:33	10:01:38 (10.02)
2023/10/18	08:42:45	18:34:08	09:51:23 (9.85)
2023/10/19	08:52:22	18:42:01	09:49:39 (9.82)
2023/10/20	08:43:18	18:36:32	09:53:14 (9.88)
2023/10/21	08:25:08	18:06:07	09:40:59 (9.68)
2023/10/24	08:38:44	18:52:14	10:13:30 (10.22)
2023/10/25	08:36:50	18:39:15	10:02:25 (10.04)
2023/10/26	08:39:46	19:14:36	10:34:50 (10.58)
2023/10/27	08:38:42	19:11:32	10:32:50 (10.54)
2023/10/28	08:24:39	18:06:12	09:41:33 (9.69)
2023/10/29	07:58:53	16:33:10	08:34:17 (8.57)
2023/10/30	07:49:54	13:04:29	05:14:35 (5.24)
2023/10/31	08:48:17	18:32:46	09:44:29 (9.74)
Gwen Cherry Oshea
2023/10/10	08:59:55	18:00:27	00:00:00 (0.00)
2023/10/27	08:55:35	19:23:27	10:27:52 (10.46)
2023/10/19	09:00:42	18:36:37	09:35:55 (9.59)
2023/10/13	09:14:49	18:11:27	08:56:38 (8.94)
2023/10/07	09:05:17	17:58:34	08:53:17 (8.88)
2023/10/30	09:30:56	13:02:38	03:31:42 (3.52)
2023/10/14	08:55:10	18:03:51	09:08:41 (9.14)
2023/10/31	08:24:31	18:24:18	09:59:47 (9.99)
2023/10/25	09:22:16	18:32:47	09:10:31 (9.17)
2023/10/02	09:28:07	12:33:31	03:05:24 (3.09)
2023/10/11	09:06:23	18:07:26	09:01:03 (9.01)
2023/10/05	09:26:31	18:34:33	09:08:02 (9.13)
2023/10/28	08:36:43	18:24:02	09:47:19 (9.78)
2023/10/20	09:00:10	18:33:34	09:33:24 (9.55)
2023/10/03	09:31:53	18:33:17	09:01:24 (9.02)
2023/10/06	09:10:33	18:34:44	09:24:11 (9.40)
2023/10/29	07:50:20	15:29:27	07:39:07 (7.65)
2023/10/17	09:00:33	18:20:27	00:00:00 (0.00)
2023/10/26	08:51:53	18:41:46	09:49:53 (9.83)
2023/10/18	08:57:32	18:27:40	09:30:08 (9.50)
2023/10/24	09:10:29	18:04:38	08:54:09 (8.90)
2023/10/01	09:23:20	12:00:27	00:00:00 (0.00)
2023/10/12	09:00:25	18:28:20	09:27:55 (9.46)
2023/10/21	09:00:56	18:22:02	09:21:06 (9.35)
2023/10/04	09:23:43	18:24:47	09:01:04 (9.01)
Henry Mays
2023/10/03	09:04:06	18:15:17	09:11:11 (9.18)
2023/10/04	08:47:53	18:14:06	09:26:13 (9.43)
2023/10/05	08:40:51	18:12:14	09:31:23 (9.52)
2023/10/06	10:00:50	18:08:41	08:07:51 (8.13)
2023/10/07	08:29:43	18:01:20	09:31:37 (9.52)
2023/10/08	08:25:17	14:06:08	05:40:51 (5.68)
2023/10/09	08:06:23	13:16:43	05:10:20 (5.17)
2023/10/10	09:02:34	18:20:05	09:17:31 (9.29)
2023/10/11	09:06:01	18:30:48	09:24:47 (9.41)
2023/10/12	09:33:23	18:50:23	09:17:00 (9.28)
2023/10/13	09:02:31	18:44:32	09:42:01 (9.70)
2023/10/14	09:03:48	18:15:43	09:11:55 (9.19)
2023/10/17	09:02:09	18:19:56	09:17:47 (9.29)
2023/10/18	09:05:41	19:47:20	10:41:39 (10.69)
2023/10/20	09:02:33	18:37:43	09:35:10 (9.58)
2023/10/21	09:04:41	18:14:01	09:09:20 (9.15)
2023/10/24	09:32:49	20:04:19	10:31:30 (10.52)
2023/10/25	09:29:06	20:07:53	10:38:47 (10.64)
2023/10/26	09:33:14	20:25:35	10:52:21 (10.87)
2023/10/27	09:30:19	20:12:26	10:42:07 (10.70)
2023/10/28	09:05:19	18:08:39	09:03:20 (9.05)
2023/10/31	09:00:44	18:09:38	09:08:54 (9.14)
Johnna Rodriguez
2023/10/03	08:56:02	18:16:06	09:20:04 (9.33)
2023/10/04	08:59:18	18:02:03	09:02:45 (9.04)
2023/10/05	08:52:22	18:13:29	09:21:07 (9.35)
2023/10/06	08:57:10	18:04:32	09:07:22 (9.12)
2023/10/07	08:59:49	18:05:14	09:05:25 (9.09)
2023/10/10	09:08:15	18:32:12	09:23:57 (9.39)
2023/10/11	09:43:44	18:34:42	08:50:58 (8.84)
2023/10/12	09:36:39	18:42:53	09:06:14 (9.10)
2023/10/13	08:59:48	18:30:14	09:30:26 (9.50)
2023/10/14	09:01:53	18:31:09	09:29:16 (9.48)
2023/10/15	09:10:00	13:21:04	00:00:04 (0.00)
2023/10/16	09:28:17	13:31:14	04:02:57 (4.04)
2023/10/17	09:03:04	18:34:45	09:31:41 (9.52)
2023/10/18	08:52:34	18:22:49	09:30:15 (9.50)
2023/10/19	09:07:57	18:44:50	09:36:53 (9.61)
2023/10/20	08:58:06	18:28:49	09:30:43 (9.51)
2023/10/21	08:13:43	17:58:45	09:45:02 (9.75)
2023/10/24	09:05:41	18:35:47	09:30:06 (9.50)
2023/10/25	08:46:50	19:02:23	10:15:33 (10.25)
2023/10/26	08:32:36	19:07:28	10:34:52 (10.58)
2023/10/27	09:07:22	19:03:03	09:55:41 (9.92)
2023/10/28	08:12:21	17:59:26	09:47:05 (9.78)
2023/10/31	10:05:24	18:39:40	08:34:16 (8.57)
Ruth Stovall
2023/10/03	08:58:09	18:04:04	09:05:55 (9.09)
2023/10/04	08:45:07	18:01:17	09:16:10 (9.26)
2023/10/05	09:03:44	18:10:30	09:06:46 (9.11)
2023/10/06	08:53:16	18:05:14	09:11:58 (9.19)
2023/10/07	09:00:38	17:59:20	08:58:42 (8.97)
2023/10/10	09:10:02	18:19:46	09:09:44 (9.16)
2023/10/11	09:27:10	18:37:22	09:10:12 (9.17)
2023/10/12	09:19:28	18:39:11	09:19:43 (9.32)
2023/10/13	09:20:48	18:12:36	08:51:48 (8.86)
2023/10/17	08:59:24	18:26:51	09:27:27 (9.45)
2023/10/18	09:10:06	18:29:56	09:19:50 (9.33)
2023/10/19	09:03:21	18:41:12	09:37:51 (9.63)
2023/10/20	08:56:41	18:27:28	09:30:47 (9.51)
2023/10/21	08:55:25	18:09:06	09:13:41 (9.22)
2023/10/22	08:44:34	13:04:23	04:19:49 (4.33)
2023/10/23	09:00:01	12:11:23	03:11:22 (3.18)
2023/10/24	09:28:36	18:42:28	09:13:52 (9.23)
2023/10/25	09:20:31	18:20:28	00:00:00 (0.00)
2023/10/26	09:16:25	19:00:33	09:44:08 (9.73)
2023/10/27	08:58:22	18:55:56	09:57:34 (9.95)
2023/10/28	08:59:31	18:04:20	09:04:49 (9.08)
2023/10/31	09:32:04	18:35:18	09:03:14 (9.05)
Nora Dulin
2023/10/03	07:16:16	18:34:21	11:18:05 (11.30)
2023/10/04	09:43:50	18:21:45	08:37:55 (8.63)
2023/10/05	09:08:12	19:34:29	10:26:17 (10.43)
2023/10/06	09:18:51	17:38:30	08:19:39 (8.32)
2023/10/07	09:16:58	18:33:34	09:16:36 (9.27)
2023/10/10	08:01:31	18:59:27	10:57:56 (10.96)
2023/10/11	08:06:38	18:30:31	10:23:53 (10.39)
2023/10/12	08:18:00	19:29:52	11:11:52 (11.19)
2023/10/13	07:48:05	19:57:09	12:09:04 (12.15)
2023/10/14	08:04:37	17:49:14	09:44:37 (9.74)
2023/10/17	08:07:39	19:18:06	11:10:27 (11.17)
2023/10/18	08:49:42	19:47:35	10:57:53 (10.96)
2023/10/19	08:58:24	19:38:06	10:39:42 (10.66)
2023/10/20	10:08:00	19:22:32	09:14:32 (9.24)
2023/10/21	08:48:44	18:07:45	09:19:01 (9.31)
2023/10/24	08:21:14	19:12:09	10:50:55 (10.84)
2023/10/25	07:52:17	17:08:59	09:16:42 (9.27)
2023/10/26	07:49:45	19:19:23	11:29:38 (11.49)
2023/10/27	08:07:22	18:35:25	10:28:03 (10.46)
2023/10/28	08:04:21	17:34:51	09:30:30 (9.50)
2023/10/29	08:04:06	16:51:46	08:47:40 (8.79)
2023/10/30	11:31:25	13:29:32	01:58:07 (1.96)
2023/10/31	07:45:42	19:32:59	11:47:17 (11.78)
Edgar Echols
2023/10/01	08:08:21	13:56:53	05:48:32 (5.80)
2023/10/02	07:15:36	11:18:36	04:03:00 (4.05)
2023/10/03	09:11:35	18:03:15	08:51:40 (8.86)
2023/10/04	08:30:19	18:12:38	09:42:19 (9.70)
2023/10/05	08:08:16	17:40:33	09:32:17 (9.53)
2023/10/06	08:27:26	18:06:03	09:38:37 (9.64)
2023/10/07	08:31:48	18:04:52	09:33:04 (9.55)
2023/10/10	09:45:07	18:05:45	08:20:38 (8.34)
2023/10/11	08:03:47	19:14:01	11:10:14 (11.17)
2023/10/12	08:36:20	18:46:29	10:10:09 (10.16)
2023/10/13	08:10:46	18:36:48	10:26:02 (10.43)
2023/10/14	08:41:06	18:15:52	09:34:46 (9.57)
2023/10/17	08:44:55	18:02:59	09:18:04 (9.30)
2023/10/18	08:08:13	17:59:45	09:51:32 (9.85)
2023/10/19	08:26:20	17:36:47	09:10:27 (9.17)
2023/10/20	08:21:32	10:38:42	02:17:10 (2.28)
2023/10/21	09:43:32	18:04:57	08:21:25 (8.35)
2023/10/22	08:37:42	14:22:27	05:44:45 (5.74)
2023/10/23	07:12:38	12:00:48	04:48:10 (4.80)
2023/10/24	09:16:09	20:05:14	10:49:05 (10.81)
2023/10/25	09:25:39	19:59:22	10:33:43 (10.56)
2023/10/26	09:30:04	20:28:58	10:58:54 (10.98)
2023/10/27	09:45:06	20:25:57	10:40:51 (10.68)
2023/10/28	08:47:41	18:16:06	09:28:25 (9.47)
2023/10/31	09:05:15	18:19:27	09:14:12 (9.23)
Mary Joyce
2023/10/03	09:27:51	18:16:01	08:48:10 (8.80)
2023/10/04	09:11:11	18:14:15	09:03:04 (9.05)
2023/10/05	08:33:46	18:12:05	09:38:19 (9.63)
2023/10/06	08:56:20	18:08:33	09:12:13 (9.20)
2023/10/07	08:49:44	18:01:10	09:11:26 (9.19)
2023/10/10	09:24:19	18:20:46	08:56:27 (8.94)
2023/10/11	08:33:23	19:16:58	10:43:35 (10.72)
2023/10/12	08:38:48	13:04:29	04:25:41 (4.42)
2023/10/13	08:38:26	18:46:41	10:08:15 (10.13)
2023/10/14	08:56:33	18:17:56	09:21:23 (9.35)
2023/10/15	08:24:04	14:31:16	06:07:12 (6.12)
2023/10/16	08:27:04	13:41:17	05:14:13 (5.23)
2023/10/17	09:26:08	19:19:07	09:52:59 (9.88)
2023/10/18	09:31:18	18:27:19	08:56:01 (8.93)
2023/10/19	09:42:01	19:50:40	10:08:39 (10.14)
2023/10/20	09:40:38	19:49:17	10:08:39 (10.14)
2023/10/21	09:43:37	18:13:55	08:30:18 (8.50)
2023/10/24	08:49:57	18:05:52	09:15:55 (9.26)
2023/10/25	09:03:59	18:44:29	09:40:30 (9.67)
2023/10/26	08:37:31	17:55:39	09:18:08 (9.30)
2023/10/27	08:54:28	18:12:32	09:18:04 (9.30)
2023/10/31	10:00:55	19:34:09	09:33:14 (9.55)
Hilda Valdez
2023/10/03	09:16:52	18:15:23	08:58:31 (8.97)
2023/10/04	08:36:24	18:04:10	09:27:46 (9.46)
2023/10/05	08:55:14	18:11:32	09:16:18 (9.27)
2023/10/06	09:03:39	18:05:44	09:02:05 (9.03)
2023/10/07	09:02:34	18:01:25	08:58:51 (8.98)
2023/10/08	07:58:29	14:05:54	06:07:25 (6.12)
2023/10/09	07:58:30	13:42:10	05:43:40 (5.72)
2023/10/10	09:02:39	18:20:50	09:18:11 (9.30)
2023/10/11	09:23:29	19:17:42	09:54:13 (9.90)
2023/10/12	10:09:48	18:50:29	08:40:41 (8.67)
2023/10/13	10:05:40	18:47:58	08:42:18 (8.70)
2023/10/14	09:39:11	18:17:51	08:38:40 (8.64)
2023/10/17	09:30:06	18:20:02	08:49:56 (8.83)
2023/10/18	09:35:16	18:01:27	08:26:11 (8.43)
2023/10/19	09:27:55	18:04:09	08:36:14 (8.60)
2023/10/20	09:30:18	18:37:50	09:07:32 (9.12)
2023/10/21	09:33:20	18:14:05	08:40:45 (8.67)
2023/10/24	09:00:22	20:04:15	11:03:53 (11.06)
2023/10/25	08:35:00	20:08:04	11:33:04 (11.55)
2023/10/26	09:46:58	20:25:30	10:38:32 (10.64)
2023/10/27	09:16:47	20:12:35	10:55:48 (10.93)
2023/10/28	08:47:46	18:08:29	09:20:43 (9.34)
2023/10/31	09:11:02	18:10:09	08:59:07 (8.98)
Troy Marquez
2023/10/01	07:56:02	15:03:38	07:07:36 (7.12)
2023/10/02	07:57:37	12:59:34	05:01:57 (5.03)
2023/10/03	09:04:01	18:15:29	09:11:28 (9.19)
2023/10/04	08:47:39	18:14:10	09:26:31 (9.44)
2023/10/05	08:40:32	18:12:10	09:31:38 (9.52)
2023/10/06	08:26:41	18:20:07	09:53:26 (9.89)
2023/10/07	08:29:39	18:02:17	09:32:38 (9.54)
2023/10/10	09:02:28	18:20:20	09:17:52 (9.29)
2023/10/11	09:05:54	19:17:52	10:11:58 (10.19)
2023/10/12	09:33:19	18:50:36	09:17:17 (9.28)
2023/10/13	09:02:08	18:47:44	09:45:36 (9.76)
2023/10/14	09:03:27	18:17:34	09:14:07 (9.23)
2023/10/17	09:02:07	18:20:08	09:18:01 (9.30)
2023/10/18	09:05:37	19:47:01	10:41:24 (10.69)
2023/10/19	08:42:53	18:03:41	09:20:48 (9.34)
2023/10/20	09:02:31	18:38:13	09:35:42 (9.59)
2023/10/21	09:04:37	18:14:21	09:09:44 (9.16)
2023/10/24	09:32:53	20:04:24	10:31:31 (10.52)
2023/10/25	09:29:01	20:07:51	10:38:50 (10.64)
2023/10/26	09:33:05	20:25:40	10:52:35 (10.87)
2023/10/27	09:30:23	20:12:30	10:42:07 (10.70)
2023/10/28	09:05:14	18:08:34	09:03:20 (9.05)
2023/10/31	09:00:37	18:10:04	09:09:27 (9.15)
Stanley Conaway
2023/10/03	09:44:19	18:06:32	08:22:13 (8.37)
2023/10/04	09:17:10	12:49:41	03:32:31 (3.54)
2023/10/05	08:33:13	17:55:03	09:21:50 (9.36)
2023/10/06	08:45:55	17:43:22	08:57:27 (8.95)
2023/10/07	08:19:40	17:30:05	09:10:25 (9.17)
2023/10/10	08:59:24	17:58:01	08:58:37 (8.97)
2023/10/11	09:33:02	17:53:49	08:20:47 (8.34)
2023/10/12	09:09:55	18:17:39	09:07:44 (9.12)
2023/10/13	09:28:01	17:58:41	08:30:40 (8.51)
2023/10/17	09:37:01	19:14:24	09:37:23 (9.62)
2023/10/18	09:45:13	19:35:11	09:49:58 (9.83)
2023/10/19	09:13:14	19:50:24	10:37:10 (10.61)
2023/10/20	08:34:47	19:31:43	10:56:56 (10.94)
2023/10/21	09:03:06	17:56:02	08:52:56 (8.88)
2023/10/24	08:46:30	18:00:55	09:14:25 (9.24)
2023/10/25	09:11:18	18:39:42	09:28:24 (9.47)
2023/10/26	09:20:33	18:08:09	08:47:36 (8.79)
2023/10/27	09:13:09	18:08:48	08:55:39 (8.92)
2023/10/28	10:38:58	17:48:45	07:09:47 (7.16)
2023/10/31	10:37:15	19:38:01	09:00:46 (9.01)
Carol Lutz
2023/10/03	08:29:24	18:29:11	09:59:47 (9.99)
2023/10/04	08:27:19	18:31:25	10:04:06 (10.06)
2023/10/05	08:19:54	18:02:06	09:42:12 (9.70)
2023/10/06	08:21:25	18:34:06	10:12:41 (10.21)
2023/10/07	08:10:08	18:00:27	09:50:19 (9.83)
2023/10/10	09:51:20	18:27:39	08:36:19 (8.60)
2023/10/11	10:00:41	19:19:12	09:18:31 (9.30)
2023/10/12	09:29:27	18:52:05	09:22:38 (9.37)
2023/10/13	09:57:10	18:38:59	08:41:49 (8.69)
2023/10/14	09:14:12	18:19:13	09:05:01 (9.08)
2023/10/15	07:38:56	13:21:32	05:42:36 (5.71)
2023/10/16	08:11:35	13:14:10	05:02:35 (5.04)
2023/10/17	08:40:00	18:35:41	09:55:41 (9.92)
2023/10/18	08:42:40	18:32:58	09:50:18 (9.83)
2023/10/19	08:52:15	18:39:28	09:47:13 (9.78)
2023/10/20	08:43:24	18:38:02	09:54:38 (9.91)
2023/10/21	08:25:18	18:07:13	09:41:55 (9.69)
2023/10/24	10:05:25	19:57:04	09:51:39 (9.86)
2023/10/25	10:02:24	20:01:34	09:59:10 (9.98)
2023/10/26	10:03:56	20:22:34	10:18:38 (10.31)
2023/10/27	09:59:45	20:05:12	10:05:27 (10.09)
2023/10/28	09:55:30	18:06:23	08:10:53 (8.18)
2023/10/31	08:48:13	18:33:07	09:44:54 (9.74)
Peggy Spencer
2023/10/03	09:05:25	18:04:11	08:58:46 (8.97)
2023/10/04	09:02:41	18:12:43	09:10:02 (9.16)
2023/10/05	08:52:26	17:40:15	08:47:49 (8.79)
2023/10/06	08:27:31	18:06:08	09:38:37 (9.64)
2023/10/07	08:31:24	18:04:59	09:33:35 (9.55)
2023/10/08	08:01:54	14:05:59	06:04:05 (6.06)
2023/10/09	08:06:01	13:22:34	05:16:33 (5.27)
2023/10/10	09:33:30	18:08:38	08:35:08 (8.58)
2023/10/11	08:44:22	19:13:50	10:29:28 (10.49)
2023/10/12	09:19:42	18:46:37	09:26:55 (9.44)
2023/10/13	08:56:20	18:38:12	09:41:52 (9.69)
2023/10/14	09:01:35	18:16:40	09:15:05 (9.25)
2023/10/17	08:56:25	18:03:20	09:06:55 (9.11)
2023/10/18	09:02:06	17:59:56	08:57:50 (8.96)
2023/10/19	09:00:19	17:36:42	08:36:23 (8.60)
2023/10/20	08:46:30	18:22:58	09:36:28 (9.60)
2023/10/21	08:41:38	18:02:55	09:21:17 (9.35)
2023/10/24	09:43:28	20:05:19	10:21:51 (10.36)
2023/10/25	09:44:27	19:58:31	10:14:04 (10.23)
2023/10/26	09:51:50	20:29:03	10:37:13 (10.62)
2023/10/27	09:54:00	12:48:46	02:54:46 (2.91)
2023/10/28	08:07:55	18:16:13	10:08:18 (10.13)
2023/10/31	09:01:19	18:20:12	09:18:53 (9.31)
Velma Williams
2023/10/03	09:49:06	18:18:59	08:29:53 (8.49)
2023/10/04	10:27:19	18:15:18	07:47:59 (7.79)
2023/10/05	09:05:54	18:20:49	09:14:55 (9.24)
2023/10/06	09:55:54	18:02:20	08:06:26 (8.10)
2023/10/07	09:00:03	17:55:56	08:55:53 (8.93)
2023/10/10	09:05:21	17:57:00	08:51:39 (8.86)
2023/10/11	09:18:36	18:00:59	08:42:23 (8.70)
2023/10/12	09:17:30	18:05:22	08:47:52 (8.79)
2023/10/13	09:13:41	18:01:05	08:47:24 (8.79)
2023/10/14	09:07:55	17:55:47	08:47:52 (8.79)
2023/10/17	10:06:26	19:08:55	09:02:29 (9.04)
2023/10/18	08:54:41	19:01:38	10:06:57 (10.11)
2023/10/19	09:56:25	19:05:38	09:09:13 (9.15)
2023/10/20	08:57:22	19:25:56	10:28:34 (10.47)
2023/10/21	09:10:37	17:59:00	08:48:23 (8.80)
2023/10/22	08:49:55	13:53:56	05:04:01 (5.06)
2023/10/23	08:01:34	12:04:16	04:02:42 (4.04)
2023/10/24	09:41:29	18:00:48	08:19:19 (8.32)
2023/10/25	09:04:38	18:00:28	08:55:50 (8.93)
2023/10/26	08:53:10	18:01:25	09:08:15 (9.13)
2023/10/27	09:01:56	18:01:34	08:59:38 (8.99)
2023/10/31	10:10:49	19:13:50	09:03:01 (9.05)
Patrick Pyles
2023/10/03	10:03:58	18:10:01	08:06:03 (8.10)
2023/10/04	09:38:29	18:03:55	08:25:26 (8.42)
2023/10/05	09:30:42	13:43:24	04:12:42 (4.21)
2023/10/20	10:54:12	19:09:48	08:15:36 (8.26)
2023/10/21	09:20:57	18:08:05	08:47:08 (8.78)
2023/10/24	09:00:14	18:00:05	00:00:00 (0.00)
2023/10/25	09:07:14	19:15:05	00:00:00 (0.00)
2023/10/26	09:00:14	18:00:05	00:00:00 (0.00)
2023/10/27	09:06:00	18:06:51	00:00:00 (0.00)
2023/10/28	09:16:13	17:57:12	08:40:59 (8.68)
2023/10/29	08:15:52	16:51:52	08:36:00 (8.6)
2023/10/30	08:13:32	12:16:16	04:02:44 (4.04)
2023/10/31	10:06:26	19:29:48	09:23:22 (9.38)
   `;

  //   const exampleText = `
  // Kathleen Robin Hughes
  // 2023/01/02	08:53:09	18:34:26	09:41:17 (9.68)
  // 2023/01/08	08:44:29	18:23:22	09:38:53 (9.64)
  // 2023/10/05	08:43:32	17:44:30	09:00:58 (9.01)
  // 2023/10/06	08:45:50	18:18:13	09:32:23 (9.53)
  // 2023/10/07	08:43:28	16:40:27	07:56:59 (7.94)
  // 2023/10/10	07:00:07	16:51:39	08:00:32 (8.00)
  // 2023/10/11	07:03:05	16:05:25	09:02:20 (9.03)
  // 2023/10/12	08:56:38	18:37:05	09:40:27 (9.67)
  // 2023/10/13	08:28:30	16:45:00	08:16:30 (8.27)
  // 2023/10/18	08:51:45	18:08:32	09:16:47 (9.27)
  // 2023/10/19	08:48:27	18:18:51	09:30:24 (9.50)
  // 2023/10/20	08:49:33	18:26:59	09:37:26 (9.62)
  // 2023/10/21	08:52:34	18:03:25	09:10:51 (9.18)
  // 2023/10/24	08:58:35	18:36:39	09:38:04 (9.63)
  // 2023/10/25	08:45:32	18:39:14	09:53:42 (9.89)
  // 2023/10/26	08:50:20	18:53:42	10:03:22 (10.05)
  // 2023/10/27	08:55:40	18:51:52	09:56:12 (9.93)
  // 2023/10/28	09:03:03	17:57:35	08:54:32 (8.90)
  // 2023/10/31	08:12:37	18:24:33	10:11:56 (10.19)
  // `;

  navigator.clipboard.writeText(exampleText);

  exampleBtn.innerHTML = 'Copied!';
});

class Overtime {
  personObject = [];
  publicDates = [];
  constructor() {
    this._getPublicHolidays();
  }

  separatePeople(data) {
    this.people = data
      .split(/(?<![a-zA-Z]|\d)\s(?!\d)/g)
      .filter(el => el && el.length > 26);
  }

  createPersonObject() {
    this.people.forEach((el, i) => {
      const [name, ...days] = el.split('\n');

      this.personObject[i] = {
        name,
        days,
      };
    });
  }

  formatDays() {
    this.personObject.forEach(person => {
      person.formatted = [];
      person.days.forEach((day, i) => {
        const [date, timeIn, timeOut, duration] = day.split('\t');
        const dayObject = {
          id: i,
          data: {
            date: new Date(date),
            timeIn: new Date(Date.parse(`${date} ${timeIn}`)),
            timeOut: new Date(Date.parse(`${date} ${timeOut}`)),
            duration,
          },
        };
        person.formatted.push(dayObject);
      });
    });
  }

  numberOfDaysInMonth() {
    this.personObject.forEach(person => {
      console.log(person);
      const month = person.formatted[0].data.date.getMonth();
      const year = person.formatted[0].data.date.getFullYear();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      person.daysInMonth = daysInMonth;
      person.currMonth = month;
      person.currYear = year;
    });
  }

  numberOfWorkdays() {
    this.personObject.forEach(person => {
      const weekDays = [];
      for (let i = 1; i <= person.daysInMonth; i++) {
        const currDate = new Date(
          person.currYear,
          person.currMonth,
          i
        ).toDateString();
        if (this._isWeekdayChecker(currDate)) {
          weekDays.push(currDate);
        }
      }
      person.weekDays = weekDays.length;
    });
  }

  calculateTotalTime() {
    // Number of days weekdays in month
    this.personObject.forEach(person => {
      person.totalNeededTime = person.weekDays * 9;
    });
  }

  calculateNormalTime() {
    // weekday hours worked under 9 hours
    this.personObject.forEach(person => {
      const normalTime = [];
      person.formatted.forEach(day => {
        const dayOfWeek = day.data.date.toDateString().slice(0, 3);
        const timeIn = day.data.timeIn;
        const timeOut = day.data.timeOut;
        const duration = Math.trunc((timeOut - timeIn) / 36000) / 100;
        if (this._isWeekdayChecker(dayOfWeek) && duration <= 9) {
          normalTime.push(duration);
        } else if (this._isWeekdayChecker(dayOfWeek) && duration > 9)
          normalTime.push(9);
      });
      if (normalTime.length >= 1) {
        person.normalTime =
          Math.trunc(normalTime.reduce((a, b) => a + b) * 100) / 100;
      } else person.normalTime = 0;
    });
  }

  calculateUnderTime() {
    // only weekdays
    this.personObject.forEach(person => {
      const underTime = [person.totalNeededTime - person.normalTime];
      person.formatted.forEach(day => {
        const dayOfWeek = day.data.date.toDateString().slice(0, 3);
        const timeIn = day.data.timeIn;
        const timeOut = day.data.timeOut;
        const duration = Math.trunc((timeOut - timeIn) / 36000) / 100;

        if (this._isWeekdayChecker(dayOfWeek) && duration < 9)
          underTime.push(Math.trunc((9 - duration) * 100) / 100);
      });
      if (underTime.length >= 1) {
        person.underTime =
          Math.trunc(underTime.reduce((a, b) => a + b) * 100) / 100;
      } else person.underTime = 0;
    });
  }

  calculateOvertime() {
    // min 30minutes
    this.personObject.forEach(person => {
      const overTime = [];
      person.formatted.forEach(day => {
        const dayOfWeek = day.data.date.toDateString().slice(0, 3);
        const timeIn = day.data.timeIn;
        const timeOut = day.data.timeOut;
        const duration = Math.trunc((timeOut - timeIn) / 36000) / 100;
        if (
          (this._isWeekdayChecker(dayOfWeek) &&
            duration > 9 &&
            duration - 9 >= 0.5) ||
          this._isSaturdayChecker(dayOfWeek)
        )
          overTime.push(
            Math.trunc((duration > 9 ? duration - 9 : duration) * 100) / 100
          );
      });
      if (overTime.length >= 1) {
        person.overTime =
          Math.trunc(overTime.reduce((a, b) => a + b) * 100) / 100;
      } else person.overTime = 0;
    });
  }

  calculateSundayTime() {
    this.personObject.forEach(person => {
      const sunday = [];
      person.formatted.forEach(day => {
        const dayOfWeek = day.data.date.toDateString().slice(0, 3);
        const timeIn = day.data.timeIn;
        const timeOut = day.data.timeOut;
        const duration = Math.trunc((timeOut - timeIn) / 36000) / 100;
        if (
          this._isSundayChecker(dayOfWeek) &&
          !this._isPublicChecker(day.data.date)
        )
          sunday.push(Math.trunc(duration * 100) / 100);
      });
      if (sunday.length >= 1) {
        person.sunday = Math.trunc(sunday.reduce((a, b) => a + b) * 100) / 100;
      } else person.sunday = 0;
    });
  }
  calculatePublicTime() {
    this.personObject.forEach(person => {
      const publicHours = [];
      person.formatted.forEach(day => {
        const dayOfWeek = day.data.date.toDateString().slice(0, 3);
        const timeIn = day.data.timeIn;
        const timeOut = day.data.timeOut;
        const duration = Math.trunc((timeOut - timeIn) / 36000) / 100;
        if (this._isPublicChecker(day.data.date))
          publicHours.push(Math.trunc(duration * 100) / 100);
      });
      if (publicHours.length >= 1) {
        person.publicHours =
          Math.trunc(publicHours.reduce((a, b) => a + b) * 100) / 100;
      } else person.publicHours = 0;
    });
  }

  renderResults() {
    this.personObject.forEach(person => {
      const markup = `
      <div class="card">
        <h2 class="heading-secondary">${person.name}</h2>
        <ul class="overtime-list">
          <li class="overtime-item">
            Normal Hours:
            <span class="results results__normal"> ${person.normalTime} </span>
          </li>
          <li class="overtime-item">
            Overtime Hours:
            <span class="results overtime"> ${person.overTime} </span>
          </li>
          <li class="overtime-item">
            Sunday Hours:
            <span class="results results__sunday"> ${person.sunday} </span>
          </li>
          <li class="overtime-item">
            Public Hours:
            <span class="results results__sunday"> ${person.publicHours} </span>
          </li>
          <li class="overtime-item">
            Undertime:
            <span class="results results__sunday"> ${person.underTime} </span>
          </li>
        </ul>
      </div>
      `;

      cardContainer.insertAdjacentHTML('beforeend', markup);
    });
  }

  // Public Holidays
  calculatePublicHolidays(data) {
    if (data) {
      this.publicDates = [];
      const dates = data.split('\n');
      dates.forEach(el => {
        const [year, month, day] = el.split('/');
        const newDate = new Date(`${year}-${month}-${day}`).toDateString();
        this.publicDates.push(newDate);
      });
      this._setPublicHolidays();
      this._renderPublicDays();
    }
    // 2023 / 01 / 01;
  }
  _isSaturdayChecker(day) {
    if (day.slice(0, 3) === 'Sat') return true;
  }

  _isWeekdayChecker(day) {
    if (
      !(day.slice(0, 3) === 'Sat') &&
      !(day.slice(0, 3) === 'Sun') &&
      !this.publicDates.includes(day)
    ) {
      return true;
    }
  }

  _isSundayChecker(day) {
    if (day.slice(0, 3) === 'Sun') {
      return true;
    }
  }
  _isPublicChecker(day) {
    if (this.publicDates.includes(day.toDateString())) {
      return true;
    }
  }

  _setPublicHolidays() {
    window.localStorage.setItem('publicDate', JSON.stringify(this.publicDates));
  }

  _getPublicHolidays() {
    const savedDates = JSON.parse(window.localStorage.getItem('publicDate'));
    if (savedDates) this.publicDates = savedDates;
    this._renderPublicDays();
  }

  _renderPublicDays() {
    publicContainer.innerHTML = '';
    this.publicDates.forEach(day => {
      const date = day.slice(4);
      const markup = `<div class="public-date">${date}</div>`;
      publicContainer.insertAdjacentHTML('beforeend', markup);
    });
  }
}

const app = new Overtime();

calculateBtn.addEventListener('click', e => {
  exampleBtn.innerHTML = 'Example Text';
  const peopleData = text.value;
  app.separatePeople(peopleData);
  app.createPersonObject();
  app.formatDays();
  app.numberOfDaysInMonth();
  app.numberOfWorkdays();
  app.calculateTotalTime();
  app.calculateNormalTime();
  app.calculateUnderTime();
  app.calculateOvertime();
  app.calculateSundayTime();
  app.calculatePublicTime();
  app.renderResults();
});

publicBtn.addEventListener('click', e => {
  const publicData = publicText.value;
  app.calculatePublicHolidays(publicData);
});

// person = {};
const object = {
  id: 0,
  data: {
    date: '2023-02-02T22:00:00.000Z',
    timeIn: '2023-10-03T06:53:09.000Z',
    timeOut: '2023-10-03T16:34:26.000Z',
    duration: '09:41:17 (9.68)',
  },
};

const numberOfDaysInMonth = function (year, month) {
  const day = new Date(year, month, 0).getDate();
  return day;
};
